// extracted by mini-css-extract-plugin
var _1 = "h5fYQ elide";
var _2 = "clRgN";
var _3 = "v6WTM";
var _4 = "CWi4s";
var _5 = "ZfB8d";
var _6 = "po1Ud";
export { _1 as "glossaryCardHeader", _2 as "glossaryCategoryContainer", _3 as "glossaryTermDescription", _4 as "icon", _5 as "name", _6 as "value" }
